import * as React from 'react'

import { AnalyticResults } from 'modules/enps/store/collections/analyticResults'
import type { AnalyticQuestionGroup, Cycle } from 'modules/enps/store/models/AnalyticResult'
import type EnpsForm from 'modules/enps/store/models/Form'

export interface Values {
  analyticResults: AnalyticResults
  answeredResults: AnalyticQuestionGroup[]
  answeredResultsCount: number
  cycle: Cycle | null
  filteredResults: AnalyticQuestionGroup[]
  filteredResultsCount: number
  form: EnpsForm
  loading: boolean
  setCycle: (cycle: Cycle) => void
  promoters: number
  detractors: number
}

export const AnalyticsContext: React.Context<Values> = React.createContext({} as Values)

export const useAnalytics = () => React.useContext(AnalyticsContext)
